module.exports = require("./fr-DZ");